import axios from "axios";
import { ip } from "./config";

/**
 * 查询奖品记录
 * @param {*} data 
 * data.platform -mini plus mall
 * data.query -链接中的传参{id:1}
 * data.path -链接路径
 * @returns 
 */
export async function selectPrizeRecords(data) {
  var resp = await axios.post(`${ip}/zskx/prize/record/select`, data);
  return resp.data;
}

/**
 * 新增奖品记录
 * @param {*} data 
 * @returns 
 */
export async function addPrizeRecords(data) {
  var resp = await axios.post(`${ip}/zskx/prize/record/add`, data);
  return resp.data;
}

/**
 * 修改抽奖次数
 * @param {*} data 
 * @returns 
 */
export async function updateCount(data) {
  var resp = await axios.post(`${ip}/zskx/prize/record/updateCount`, data);
  return resp.data;
}

